export interface IFleetData {
  uid: string;
  name: string;
  genericName?: string;
  version: string;
  ships: IFleetShip[];
  heroes: IFleetHero[];
  titles: IFleetTitle[];
  upgrades: IShipUpgrade[];
  weapons: IShipWeapon[];
  specialRules: IFtlRule[];
  coverImagePath: string;
}

export interface IFleetShip {
  id: string;
  fleetId: string;
  name: string;
  class: ShipClass;
  slots: number;
  cost: number;
  move: number;
  cruise: number;
  range: number;
  att: number;
  str: number;
  evade: number;
  tough: number;
  special: string[];
  squadron: boolean;
  common?: boolean;
}

export interface IFleetShipSelection extends IFleetShip {
  selectionId: string;
  customName: string;
  notes: string;
  hero?: IFleetHero;
  title?: IFleetTitle;
  systems: IShipUpgrade[];
  weapons: IShipWeapon[];
  count: number;
  xp: number;
  traits: string[];
}

export interface IFleetHero {
  id: string;
  name: string;
  cost: number;
  rule: string;
  common?: boolean;
}

export interface IFleetTitle {
  id: string;
  name: string;
  cost: number;
  rule: string;
  common?: boolean;
}

export interface IShipUpgrade {
  id: string;
  name: string;
  rule: string;
  common?: boolean;
  damage?: number;
}

export interface IShipWeapon {
  id: string;
  name: string;
  range: number;
  attacks: number;
  str: number;
  special: string[];
  facing?: ShipWeaponFacing;
  common?: boolean;
  damage?: number;
}

export interface IFtlRule {
  id: string;
  name: string;
  rule: string;
}

export enum ShipWeaponFacing {
  front,
  sides,
  rear,
  turret
}

export enum ShipClass {
  Heavy,
  Medium,
  Light,
  Squadron
}
